import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import CringeShell from './CringeShell';
import { clearGameTimer } from './hooks';

const Arrow = () => (
  <svg width="66px" height="43px" viewBox="0 0 66 43" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path className="cr-arrow-1" d="M40.15 3.89L43.98.14a.5.5 0 01.7 0l21.01 20.65a1 1 0 010 1.43L44.68 42.86a.5.5 0 01-.7 0l-3.82-3.75a.5.5 0 010-.71l16.84-16.54a.5.5 0 000-.71L40.15 4.61a.5.5 0 010-.72z" fill="#FFF" />
      <path className="cr-arrow-2" d="M20.15 3.89L23.98.14a.5.5 0 01.7 0l21.01 20.65a1 1 0 010 1.43L24.68 42.86a.5.5 0 01-.7 0l-3.82-3.75a.5.5 0 010-.71l16.84-16.54a.5.5 0 000-.71L20.15 4.61a.5.5 0 010-.72z" fill="#FFF" />
      <path className="cr-arrow-3" d="M.15 3.89L3.98.14a.5.5 0 01.7 0l21.01 20.65a1 1 0 010 1.43L4.68 42.86a.5.5 0 01-.7 0L.15 39.11a.5.5 0 010-.71l16.84-16.54a.5.5 0 000-.71L.15 4.61a.5.5 0 010-.72z" fill="#FFF" />
    </g>
  </svg>
);

// index.php: logo + BEGIN PLAY -> story. Players who finished all five stages are turned away.
export default function CringeIndex() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { session, game } = useSelector((s) => s.cringe);

  // index.php deleted the "gettime" cookie: the clock restarts from the saved time.
  useEffect(() => {
    if (session) clearGameTimer(session);
  }, [session]);

  useEffect(() => {
    if (game?.gameover) {
      Swal.fire({ text: 'You have played this game already', icon: 'error', allowOutsideClick: false }).then(() => {
        const base = process.env.REACT_APP_BASE_URL;
        window.location.href = session?.gameId ? `${base}/game-detail/${session.gameId}` : session?.backButtonRedirect || base;
      });
    }
  }, [game, session]);

  return (
    <CringeShell bg="bg_desk.png" bgMob="bg_mob.png" className="cr-index">
      <div className="cr-index-inner">
        <img src="/cringe/img/Logo_Cringe.png" className="cr-index-logo" alt="Cringe who stole Christmas" />
        {session && (
          <button type="button" className="cr-begin" onClick={() => navigate({ pathname: '/story', search })}>
            <span>BEGIN PLAY</span>
            <span className="cr-begin-arrow"><Arrow /></span>
          </button>
        )}
      </div>
    </CringeShell>
  );
}
